const size = {
  tablet: 1350,
  mobile: { width: 834, height: 500 },
};

export default size;
